import React, { useEffect } from "react";
import { decryptMessage } from "../helper/data-encryption";
import LoadingCM from "./loading";
import Cookies from "js-cookie";

export default function AuthCm({
  auth,
  setAuth = (e) => console.log(e),
  setErr,
}) {
  const getUserInfo = async (token) => {
    const res = await fetch("https://api.dana-institute.ir/api/exam/info", {
      mode: "cors",
      headers: {
        Authorization: "Bearer " + decryptMessage(token),
      },
    });

    if (res.status === 200) {
      const data = await res.json();
      setAuth((prev) => ({
        ...prev,
        data,
        loading: false,
      }));
      return;
    }
    if (res.status === 401) {
      setErr(401);
      return;
    }
    setAuth((prev) => ({
      ...prev,
      loading: false,
    }));
    setErr(401);
  };

  useEffect(() => {
    const token = Cookies.get("user_token");
    getUserInfo(token);

    const timer = setTimeout(() => {
      setAuth((prev) => ({
        ...prev,
        loading: false,
      }));
      setErr(401);
    }, 20000);

    return () => {
      clearTimeout(timer);
    };
  }, [setAuth, setErr]);

  return (
    <>
      {auth.loading ? (
        <div className="mt-5 m-auto !font-dana-bold w-max my-10 flex flex-col rounded-xl justify-center items-center bg-white p-32 font-kalameh text-4xl max-[800px]:p-4 max-[800px]:w-full max-[600px]:text-xl absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
          <LoadingCM title="در حال احراز هویت" />
        </div>
      ) : (
        ""
      )}
    </>
  );
}
